import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import { ArrowDown, IsOpen, Right, Trash, ArrowUp, Check } from '../../../components/Icon';
import { HBox, VBox } from '../../../components/Box';
import { DEP_FINANCE } from '../../../components/Permission/constants';
import { fetchVehicleInvoices } from '../../Invoices/actions';
import { selectWorks, selectPermissions, selectMe } from '../../Api/selectors';
import { selectPaginator } from '../../Invoices/selectors';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import styles from './CardVehicleTransportOrder.module.css';
import { hasPermissions } from '../../../utils/helpers/permissions';
import { setVehicleProperties, setVehicleProperty, deleteVehicleProperty, fetchVehicle } from '../actions';

import {
  applyTransportOrderFilters,
  deleteTransportOrder,
  editTransportOrder,
  updateTransportOrderFilter,
} from '../../TransportOrders/actions';
import { selectTransportOrderFilter, selectTransportOrders } from '../../TransportOrders/selectors';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { TransportOrderCreateModal } from '../../TransportOrders/components/createTransportOrder';
import {
  APPLY_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_FILTER,
  REQUEST_TRANSPORT_ORDERS,
  TRANSPORT_ORDER_STATUS,
} from '../../TransportOrders/constants';
import { VehicleStatusLabel } from './VehicleStatusLabel';
import { Cell, List, Row } from '../../../components/List';
import { getDate } from '../../Vehicles/helpers';
import { getPropByName } from '../../../utils/props';
dayjs.extend(customParseFormat);
import { parseCompanyPhoneNumber } from '../../TransportOrders/helpers';
import { Button } from '../../../components/Buttons';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { formatCurrency } from '../../../utils/string';
import { OnMouseOverNotification } from './OnMouseOverNotification';

const STATE = { searchString: '', isOpen: false, takeout: false };

const Container = styled.div`
  .started {
    margin: 12px 0;
    font-weight: 600;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    margin: 12px 0 0;
  }
  .address {
    border: 1px solid var(--color-new-grey);
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid var(--color-new-secondary);
    }
  }
  .dropdown-block {
    min-height: 300px;
  }

  .dropdown {
    min-width: 250px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleTransportOrderCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.setTransportOrderFilter();
    if (hasPermissions(this.props.permissions, DEP_FINANCE)) {
      this.setState({ isOpen: true });
    }
  }

  reset() {
    this.setState({
      init: false,
      direction: 'incoming',
      is_nl: null,
      takeout: false,
      isOpen: false,
      showIncomingAddressEdit: false,
      showOutgoingAddressEdit: false,
      showIndividualAddressEdit: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!(JSON.stringify(prevProps.filter) === JSON.stringify(this.props.filter))) {
      this.props.applyFilter();
    }

    // detect vehicleId change -> reset search string
    const getVehicleId = (filter) =>
      filter?.properties?.find((p) => p?.key === "vehicleId")?.value?.[0] || "";

    const currentVehicleId = getVehicleId(this.props.filter);
    const prevVehicleId = getVehicleId(prevProps.filter);

    if (currentVehicleId !== prevVehicleId) {
      this.props.setSearchString("");
    }
  }

  get deletingDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY hh:mm');
  }

  getLogs(transportOrder) {
    if (!transportOrder.deleteLogs) return '';

    const logs = JSON.parse(transportOrder.deleteLogs);

    return `${logs?.date} ${logs?.name} ${logs?.surname}`;
  }

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset));
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.searchString);
    }
  };

  doSearch() {
    this.props.setSearchString(this.state.searchString);
  }

  handleDelete = transportOrderId => {
    if (!confirm('Delete transport?')) return;
    const deleteLogs = {
      name: getPropByName(this.props.me, 'name'),
      surname: getPropByName(this.props.me, 'surname'),
      date: this.deletingDate,
    };

    this.props.edit(
      transportOrderId,
      { id: transportOrderId, status: TRANSPORT_ORDER_STATUS.Canceled, deleteLogs: JSON.stringify(deleteLogs) },
      result => {
        if (result?.id) {
          this.props.applyFilter();
        }
      },
    );
  };

  render() {
    if (this.props.work) return <LoadingDetailsPageCard />;
    if (this.state.takeout) return this.renderTakeoutModal();

    return (
      <>
        <HBox vCenter style={{ marginBottom: '10px' }}>
          <h2 className="card-title mb-0 text-muted">{this.lbl('company.info.data.transport_orders')}</h2>
          <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
            <IsOpen />
          </div>
        </HBox>
        <div className={styles.ContainerTransportOrders}>
          {this.props.transportOrders?.map(t => {
            return (
              <div key={t?.id}>
                <div className={styles.Item}>
                  <HBox left={window.innerWidth > 768} right={window.innerWidth <= 768} gap={0}>
                    {t?.type == 'incoming' ? (
                      <span style={{ color: '#00BFAE' }}>
                        <ArrowDown />
                      </span>
                    ) : (
                      <span style={{ color: '#cc0040' }}>
                        <ArrowUp />
                      </span>
                    )}
                  </HBox>

                  <HBox left gap={4}>
                    <strong>{t?.companyFrom?.name}</strong>
                  </HBox>
                  <div>{window.innerWidth < 768 ? <ArrowDown /> : <Right />}</div>
                  <HBox left gap={4}>
                    <strong>{t?.companyTo?.name}</strong>
                  </HBox>
                  <HBox left gap={4}>
                    <VBox left>
                      <strong>{t?.transporter?.name}</strong>
                      <strong>{formatCurrency(this.props.vehicle?.total_transport_cost)}</strong>
                    </VBox>
                  </HBox>

                  <HBox flip gap={4}>
                    <VBox right={window.innerWidth < 768}>
                      <VehicleStatusLabel key={`${t?.id}`} status={t?.status} overview={'double'}>
                        {this.lbl('transport_order.filter.' + t?.status)}
                      </VehicleStatusLabel>
                    </VBox>
                    <HBox right={window.innerWidth < 768}>
                      {t?.status === TRANSPORT_ORDER_STATUS.Canceled && this.getLogs(t)}
                      {t?.status === TRANSPORT_ORDER_STATUS.Initiated && getDate(t?.datePlanned)}
                      {t?.status === TRANSPORT_ORDER_STATUS.Requested && getDate(t?.dateRequested)}
                      {t?.status === TRANSPORT_ORDER_STATUS.Done && getDate(t?.dateDone)}
                    </HBox>
                  </HBox>

                  <div className="d-flex gap-1 justify-content-end">
                    <TransportOrderCreateModal vehicle={this.props.vehicle} transportOrderId={t?.id} />
                    {t.status === TRANSPORT_ORDER_STATUS.Requested && (
                      <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.handleDelete(t?.id)}>
                        <Trash />
                      </ButtonComponent>
                    )}
                  </div>
                  <div
                    style={{ marginLeft: 'auto' }}
                    onClick={() => this.setState({ [`isOrderOpen_${t.id}`]: !this.state?.[`isOrderOpen_${t.id}`] })}
                  >
                    <IsOpen />
                  </div>
                </div>
                {this.state?.[`isOrderOpen_${t.id}`] && (
                  <>
                    <div className="d-flex gap-3 p-4">
                      <div className={`card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary`}>
                        <p className="text-dark fw-medium">{t?.companyFrom?.name}</p>
                        <p className="text-muted m-0">{t?.addressFrom?.addressLine1}</p>
                        <p className="text-muted m-0">
                          {t?.addressFrom?.postcode} {t?.addressFrom?.city}
                        </p>
                        <p className="text-dark fw-medium m-0">{parseCompanyPhoneNumber(t?.companyFrom)}</p>
                      </div>
                      <div>
                        <Right />
                      </div>
                      <div className={`card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary`}>
                        <p className="text-dark fw-medium">{t?.companyTo?.name}</p>
                        <p className="text-muted m-0">{t?.addressTo?.addressLine1}</p>
                        <p className="text-muted m-0">
                          {t?.addressTo?.postcode} {t?.addressTo?.city}
                        </p>
                        <p className="text-dark fw-medium m-0">{parseCompanyPhoneNumber(t?.companyTo)}</p>
                      </div>
                    </div>
                    <List>
                      {[
                        { key: 'status', label: 'status' },
                        { key: 'createdAt', label: 'createdAt' },
                        { key: 'datePlanned', label: 'datePlanned' },
                        { key: 'dateToPlan', label: 'dateToPlan' },
                        { key: 'scheduledDate', label: 'scheduledDate' },
                        { key: 'transporter.name', label: 'transporter' },
                        { key: 'remarks', label: 'remarks' },
                        {
                          key: 'vehicle.total_transport_cost',
                          label: 'total_transport_cost',
                        },
                        {
                          key: 'vehicle.transported_vehicles',
                          label: 'transported_vehicles',
                        },
                      ].map(({ key, label }) => {
                        let value = key.split('.').reduce((obj, field) => obj?.[field], t); // Safe deep access

                        // Format date fields
                        if (['datePlanned', 'dateToPlan', 'scheduledDate', 'createdAt'].includes(key) && value) {
                          value = new Date(value).toLocaleDateString('nl-NL', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          });
                        }

                        if (['total_transport_cost'].includes(label) && value) {
                          return (
                            <Row key={key}>
                              <Cell>{this.lbl(`vehicle.property.${label}`)}</Cell>
                              <Cell>{value && formatCurrency(value)}</Cell>
                            </Row>
                          );
                        }
                        if (['transported_vehicles'].includes(label) && value) {
                          let transportedVehicles = [];
                          try {
                            transportedVehicles = JSON.parse(this.props.vehicle?.transported_vehicles || '[]');
                            if (!Array.isArray(transportedVehicles)) {
                              transportedVehicles = [];
                            }
                          } catch (e) {
                            transportedVehicles = [];
                          }
                          return (
                            <Row key={key}>
                              <Cell>{this.lbl(`vehicle.property.${label}`)}</Cell>

                              {transportedVehicles.length > 0 && (
                                <Cell>
                                  <HBox left vCenter>
                                    {`${transportedVehicles?.length} pieces`}

                                    <OnMouseOverNotification
                                      minWidth={'250px'}
                                      message={[
                                        ...transportedVehicles?.filter(v => v?.id !== this.props.vehicle?.id),
                                        { id: this.props.vehicle.id, vin: this.props.vehicle.vin, last: true },
                                      ].map(v => (
                                        <div key={v?.id}>
                                          {v?.vin ?? v?.id} {v?.last && '*'}
                                        </div>
                                      ))}
                                    />
                                  </HBox>
                                </Cell>
                              )}
                            </Row>
                          );
                        }

                        return (
                          <Row key={key}>
                            <Cell>{this.lbl(`vehicle.property.${label}`)}</Cell>

                            <Cell>{
                                key === 'status'
                                  ? (value && this.lbl(`transport_order.filter.${value}`))
                                  : (value ?? '')
                              }</Cell>

                          </Row>
                        );
                      })}
                    </List>
                  </>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: '10px' }}></div>
        <TransportOrderCreateModal vehicle={this.props.vehicle} from_location={'vehicle_detail'} />
        <div>
          <Button className={styles.button} onClick={() => this.setState({ takeout: true })}>
            Klaarzetten&nbsp;
            {this.props.vehicle.task_move_car_for_takeout == 'front' ? (
              'VOOR'
            ) : this.props.vehicle.task_move_car_for_takeout == 'back' ? (
              'ACHTER'
            ) : this.props.vehicle.task_move_car_for_takeout == 'done' ? (
              <Check />
            ) : (
              ''
            )}
          </Button>
        </div>
      </>
    );
  }

  renderTakeoutModal() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title="Klaarzetten">
        <Container>
          <VBox className={styles.containerButtonModal}>
            {['front', 'back', 'done', '0'].map(n => (
              <Button className={styles.buttonModal} onClick={() => this.props.takeout(n, this.reset.bind(this))} key={n}>
                {this.lbl(`vehicle.property.task_move_car_for_takeout.${n}`)}
              </Button>
            ))}
          </VBox>
        </Container>
      </ModalComponent>
    );
  }
}

VehicleTransportOrderCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transportOrders: selectTransportOrders(),
    paginator: selectPaginator(),
    work: selectWorks([REQUEST_TRANSPORT_ORDER_FILTER, APPLY_TRANSPORT_ORDER_FILTERS, REQUEST_TRANSPORT_ORDERS]),
    filter: selectTransportOrderFilter(),
    permissions: selectPermissions(),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    takeout(id, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_move_car_for_takeout', id, callback));
    },
    changeFilter: offset => {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, '', offset));
    },
    setTransportOrderFilter: () => {
      dispatch(
        updateTransportOrderFilter(
          {
            key: 'vehicleId',
            value: [ownProps.vehicle?.id?.toString()?.toLowerCase()],
            label: ['vehicleId'],
            type: 'single',
          },
          { getDeleted: true },
        ),
      );
    },
    applyFilter: () => {
      dispatch(applyTransportOrderFilters());
    },
    setSearchString(text) {
      dispatch(applyTransportOrderFilters());
    },
    edit(id, dto, callback) {
      dispatch(editTransportOrder(id, dto, callback));
    },
    delete(transportOrderId, callback) {
      dispatch(deleteTransportOrder(transportOrderId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleTransportOrderCard = compose(withConnect, withRouter)(VehicleTransportOrderCardComp);
